import { render } from "./PlatformLogs.vue?vue&type=template&id=2c66198a&scoped=true&ts=true"
import script from "./PlatformLogs.vue?vue&type=script&lang=ts"
export * from "./PlatformLogs.vue?vue&type=script&lang=ts"

import "./PlatformLogs.vue?vue&type=style&index=0&id=2c66198a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c66198a"]])

export default __exports__